import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ChatsService } from './api/chats.service';
import { CollectorConfigService } from './api/collectorConfig.service';
import { DashboardService } from './api/dashboard.service';
import { DefaultService } from './api/default.service';
import { LagService } from './api/lag.service';
import { LogsService } from './api/logs.service';
import { RequestsService } from './api/requests.service';
import { StatusService } from './api/status.service';
import { ZombieService } from './api/zombie.service';
import { ZombiesService } from './api/zombies.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ChatsService,
    CollectorConfigService,
    DashboardService,
    DefaultService,
    LagService,
    LogsService,
    RequestsService,
    StatusService,
    ZombieService,
    ZombiesService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
